window.debug=function(){function n(n){!e||!o&&i&&i.log||e.apply(r,n)}function t(n){return a>0?a>n:f.length+a<=n}for(var e,o,r=this,l=Array.prototype.slice,i=r.console,u={},a=9,f=["error","warn","info","debug","log"],c="assert clear count dir dirxml exception group groupCollapsed groupEnd profile profileEnd table time timeEnd trace".split(" "),p=c.length,g=[];--p>=0;)!function(n){u[n]=function(){0!==a&&i&&i[n]&&i[n].apply(i,arguments)}}(c[p]);for(p=f.length;--p>=0;)!function(e,o){u[o]=function(){var u=l.call(arguments),a=[o].concat(u);g.push(a),n(a),i&&t(e)&&(i.firebug?i[o].apply(r,u):i[o]?i[o](u):i.log(u))}}(p,f[p]);return u.setLevel=function(n){a="number"==typeof n?n:9},u.setCallback=function(){var t=l.call(arguments),r=g.length,i=r;for(e=t.shift()||null,o="boolean"==typeof t[0]?t.shift():!1,i-="number"==typeof t[0]?t.shift():r;r>i;)n(g[i++])},u}();

/*
|--------------------------------------------------------------------------
| Ads
|--------------------------------------------------------------------------
*/

/*	
|--------------------------------------------------------------------------
| GetURLParameter: Utilities
|--------------------------------------------------------------------------
*/
/**
 * @namespace -- Retrive URL parameter  
 */
__gh__webApp.utilities.GetURLParameter = {
	
	/**
	 * Initialize
	 */
	"init": function(sParam){

		    var sPageURL = window.location.search.substring(1);
		    var sURLVariables = sPageURL.split('&');
		    for (var i = 0; i < sURLVariables.length; i++) 
		    {
		        var sParameterName = sURLVariables[i].split('=');
		        if (sParameterName[0] == sParam) 
		        {
		            return sParameterName[1];
		        }
		    }	
	}

};


/**
 * @namespace
 */
//__gh__webApp.ads = __gh__webApp.ads || {}; //moved to js/global/webApp/_namespaces.js 



/**
 * DFP @namespace
 //Global DFP variables
var googletag=googletag||{},
gptAdSlots=[],
dfpIsLoaded = false, // Keep track of if we've already tried to load gpt.js before
dfpFirstLevelAdUnit= __gh__coreData["3rdPartyData"].ads.dfp.firstLevelAdUnit;
dfpSecondLevelAdUnit='',
krux_catlist='',
defaultSlotsJSON=defaultSlotsJSON||'',
__gh__articlePage_articleLoaded=false;
__gh__coreData["3rdPartyData"].ads.dfp.topBarSponsor
 */

/*
|--------------------------------------------------------------------------
| Ads: DFP
|--------------------------------------------------------------------------
Avoid race conditions by making sure to respect the usual timing of GPT. Example valid partial orderings include:
**Define-Enable-Display**
	Define page-level settings
	Define slots
	enableServices()
	Display slots

------->**Enable-Define-Display**<---- Method used below
	Define page-level settings
	enableServices()
	Define slots
	Display slots
*/


/*
|------------------------------------------------------------------------------------------------------------------------------------
| ADS INITIALIZATION:
| runs:
| 		(__gh__webApp.ads.dfp.init();
|		__gh__webApp.utilities.lazyAds.init();)
|		OR
|		(ads.amazonHeader.init();)
|		AND
|		__gh__webApp.ads.nativo.init();
|------------------------------------------------------------------------------------------------------------------------------------
*/
__gh__webApp.ads.init = function(){
    var utilities 	= __gh__webApp.utilities,
		ads			= __gh__webApp.ads,
		currentPage = __gh__webApp.currentPage;

		if(!__gh__adsLoaded){
			ads.pageFair.init();
			if (ads.dfp.isDisabled()) {debug.log("DFP disabled");return;}
			ads.dfp.loadVars();
			ads.amazonHeader.init();	
			if (!currentPage.isArticle()){ads.nativo.init();}
			__gh__adsLoaded = true;
		}
		//debug.info('Ads Init __gh__webApp.ads.init called')
};	



/**
 * @namespace
 */
 __gh__webApp.ads.dfp = {
	 
	 
	 "init": function(){

		var utilities 	= __gh__webApp.utilities,
			templateType= __gh__coreData.globalVariables.ads.dfpTemplateType;
			
			debug.log('templateType= '+templateType)
		
		utilities.lazyAds.init();
		
		//var blockingValue = (typeof(defslot_a) === "undefined") ? true : false; 
		//if(__gh__coreData.globalVariables.ads.dfpTemplateType===false||blockingValue===true){return;} //exit DFP setup
		if(__gh__coreData.globalVariables.ads.dfpTemplateType===false){return;} //exit DFP setup
		
		if(this.utilPiiCheck()){return;} //exit DFP setup
		
		//Library
		this.loadLibrary();
		
		if(__gh__webApp.utilities.GetURLParameter.init('disable')!='indexhb'){
			try{
				__gh__webApp.ads.indexHeader.init();
			}
			catch(e){
				debug.log('Error loading index Header. '+e)
				__gh__webApp.ads.indexHeader.loadFallback();
			}
		}
		else{
			__gh__webApp.ads.indexHeader.loadFallback();
		}
		
		//Load base targeting
	    this.loadBaseTargeting(templateType);
		
	    //methods
		this.loadMethods();

	    //Load base slots
	    this.loadBaseSlots(templateType);
	    
	    //slots rendered event listener
	    this.eventSlotsRendered();
	    
	    this.topBarSponsor();

	},
	"loadVars": function(){
		try{
			__gh__webApp.common.loadScript({
				"text"			: "var googletag=googletag||{},\r\ngptAdSlots=[],\r\ndfpIsLoaded = false,\r\n\/\/dfpNetworkId= __gh__coreData[\"3rdPartyData\"].ads.dfp.id,\r\n\/\/dfpNetworkId=\'11564835\',\r\ndfpFirstLevelAdUnit=__gh__coreData[\"3rdPartyData\"].ads.dfp.firstLevelAdUnit,\r\ndfpSecondLevelAdUnit=\'\',\r\n krux_catlist=\'\',defaultSlotsJSON=defaultSlotsJSON||\'\',__gh__articlePage_articleLoaded=false;"
			});
		}
		catch(e){
			 debug.info('Error loading global vars. '+e)
		}
	},
	/**
	 * Set Configuration
	 */
	 "config": function() {
		try{
		//select the template and json feed needed

			var	currentPage 	   = __gh__webApp.currentPage,
				defaultSlots       = null,
				slotName		   = null,
				dfpNameSpace=__gh__webApp.ads.dfp
				pageData		   = __gh__coreData.pageData,
				templateType       = null,
				shimClass		   = null,
				updateTrigger	   = true;
				__gh__coreData.globalVariables.ads = __gh__coreData.globalVariables.ads || {},
				__gh__coreData.globalVariables.ads.dfpTemplateType='',
				__gh__coreData.globalVariables.ads.lazyStart = 0,
				__gh__coreData.globalVariables.ads.dfpTemplateType= null;
				
			//NOTE Get function/mehtod build into currentPage Object to return (currentPage.Get)
			if (currentPage.isHome()){
				__gh__coreData.globalVariables.ads.dfpTemplateType = "homepage";
				dfpSecondLevelAdUnit='/homepage';	
			}
			else if (currentPage.isVideo()){
				__gh__coreData.globalVariables.ads.dfpTemplateType = "sectionVideo";
				debug.info("video")
				dfpSecondLevelAdUnit='/video';

			}
			else if (pageData.categoryID=='PHOTOGALLERY'){
				__gh__coreData.globalVariables.ads.dfpTemplateType = "sectionPhoto";
				debug.info("photo gallery")
				dfpSecondLevelAdUnit='/photos';
			    
			}
			else if (currentPage.isSectionStandard()||currentPage.isSectionEnhanced()||currentPage.isSectionBasic()||currentPage.isImageDriven()||currentPage.is101Things()){
				__gh__coreData.globalVariables.ads.dfpTemplateType = "sectionStandard";

			}
			else if (currentPage.isArticle()){
				__gh__coreData.globalVariables.ads.dfpTemplateType = "article";

					
				var commonJS = __gh__webApp.common,
				articleStart = commonJS.getObjectProperty(__gh__coreData["3rdPartyData"], "ads.dfp.articleStart");
				
				//debug.log("articleStart="+articleStart);
				if(typeof(articleStart) == 'number'){
					if(articleStart > 6){articleStart=6;}
					if(articleStart < 2){articleStart=2;}
					__gh__coreData.globalVariables.ads.lazyStart=articleStart-1;
					//debug.log("__gh__coreData.globalVariables.ads.lazyStart="+__gh__coreData.globalVariables.ads.lazyStart)
				}else{
					__gh__coreData.globalVariables.ads.lazyStart=1;
				}
				
				//base 300x250
				//slotName='baseMedRec';
				//shimClass='ad-lazy';
				//updateTrigger=true;
				//dfpNameSpace.baseAdShim(slotName,shimClass,updateTrigger);
			}
			else if (typeof(initAdData) == 'function') { 
				initAdData(); 
				templateType=__gh__coreData.globalVariables.ads.dfpTemplateType;
				dfpSecondLevelAdUnit=__gh__coreData.globalVariables.ads.dfpSecondLevel;
				
				var k = 'keyword';
				
				try{__gh__webApp.ads.dfp.buildKruxCatlist(k,__gh__coreData.globalVariables.ads.keywords,o='add')}catch(e){debug.info('Error building krux catlist using __gh__coreData.globalVariables.ads.keywords. '+e)}
				try{__gh__webApp.ads.dfp.buildKruxCatlist(k,__gh__coreData.pageData.profileName,o='add')}catch(e){debug.info('Error building krux catlist using profileName. '+e)}
				debug.info('templateType= '+__gh__coreData.globalVariables.ads.dfpTemplateType)
				//tmpl = templateType;
				
				if(templateType!=='legacyHeader'&&templateType!=='search'&&dfpSecondLevelAdUnit!=='/auto'){
					slotName='baseLeaderboard';
					var appendID='content';
			    }
			    
			    this.utilCheckLayNewAds(dfpSecondLevelAdUnit)
    
			}
			else {
				debug.info('Error: No DFP template defined');
				__gh__coreData.globalVariables.ads.dfpTemplateType = "vertical";//Ryan attention. Changed to vertical from section?
				return tmpl;
			}
			
			try{
				if(__gh__coreData.globalVariables.ads.dfpTemplateType == "sectionStandard") {
						//dfpSecondLevelAdUnit=pageData.buckets[0].adCode;
						//pageData.buckets[0].taxonomy
						var k = 'keyword';
						try{__gh__webApp.ads.dfp.buildKruxCatlist(k,pageData.buckets[0].taxonomy.toString(),o='replace')}catch(e){debug.info('Error building krux catlist using profile taxo. '+e)}
						//try{krux_catlist=pageData.buckets[0].taxonomy.toString().toLowerCase();}catch(e){debug.info('Error setting second level using profile taxo'+e)}
						
						try{__gh__webApp.ads.dfp.buildKruxCatlist(k,pageData.buckets[0].items.main[0].taxonomy.toString(),o='add')}catch(e){debug.info('Error building krux catlist using bucket item taxo. '+e)}
						
						try{__gh__webApp.ads.dfp.buildKruxCatlist(k,__gh__coreData.pageData.profileName,o='add')}catch(e){debug.info('Error building krux catlist using profileName. '+e)}
						//krux_catlist+=','+pageData.buckets[0].items.main[0].taxonomy.toString().toLowerCase();
						
						//krux_catlist+=','+pageData.buckets[0].title.toString().toLowerCase();
						//debug.log('section krux_catlist = '+krux_catlist)
						dfpSecondLevelAdUnit=dfpNameSpace.defineSecondLevel(krux_catlist);
						debug.log('section dfpSecondLevelAdUnit = '+dfpSecondLevelAdUnit)
				}
			}
			catch(e){
				debug.info('Error setting second section level ad unit'+e)
				dfpSecondLevelAdUnit='/news';
			}
			
			try{
				if(dfpSecondLevelAdUnit!== '' && dfpSecondLevelAdUnit.substring(0,1) !== '/') {dfpSecondLevelAdUnit='/'+dfpSecondLevelAdUnit;}
			}
			catch(e){
				debug.info('Error setting section level ad unit'+e)
			}
			
			//debug.info('tmpl='+tmpl)
			
			if(__gh__coreData.globalVariables.ads.dfpTemplateType == 'noads'){
				return false;
			}
			else {
				defaultSlotsJSON   = tmplDefinitionsJSON.template[__gh__coreData.globalVariables.ads.dfpTemplateType].slotFeed; 
				//debug.info('DFP defaultSlotsJSON= '+defaultSlotsJSON);
				return __gh__coreData.globalVariables.ads.dfpTemplateType;
			}

		}
		catch(e){
				debug.info('Error loading DFP configuration'+e)
				return false;
			}
	 },
	 
	/**
	 * Load the dfp library
	 */
	"loadLibrary": function(){
		try{
		//window.googletag = window.googletag || {};googletag.cmd=googletag.cmd||[],function(){var t=document.createElement("script");t.async=!0,t.type="text/javascript";var e="https:"==document.location.protocol;t.src=(e?"https:":"http:")+"//www.googletagservices.com/tag/js/gpt.js";var o=document.getElementsByTagName("script")[0];o.parentNode.insertBefore(t,o)}();
		
		// make sure we don't load gpt.js multiple times
            dfpIsLoaded = dfpIsLoaded || $('script[src*="googletagservices.com/tag/js/gpt.js"]').length;
            if (dfpIsLoaded) {
                return;
            }

            var loaded = $.Deferred();

            window.googletag = window.googletag || {};
            window.googletag.cmd = window.googletag.cmd || [];

            var gads = document.createElement('script');
            gads.async = true;
            gads.type = 'text/javascript';

            // Adblock blocks the load of Ad scripts... so we check for that
            gads.onerror = function () {
	            // dfpBlocked();
                debug.info('gaads onerror ads blocked!')
            };

            gads.onload = function() {
                // this will work with ghostery:
                if (!googletag._loadStarted_) {
                    googletag._adBlocked_ = true;
                    //execBlockEvents();
                }
                loaded.resolve();
            };

            var useSSL = 'https:' === document.location.protocol;
            gads.src = (useSSL ? 'https:' : 'http:') +
            '//www.googletagservices.com/tag/js/gpt.js';
            var node = document.getElementsByTagName('script')[0];
            node.parentNode.insertBefore(gads, node);

            // Adblock plus seems to hide blocked scripts... so we check for that
            if (gads.style.display === 'none') {
               debug.info('display none check: ads blocked!')
            }

            return loaded;
		
		
		}
		catch(e){
			debug.info('Error loading DFP library'+e)
		}
	}, 
	
	/**
	 * Load Targeting
	 */
	"loadBaseTargeting": function(pgtype) {
		try{
			
			var testKey='test';
			
			if(__gh__webApp.utilities.GetURLParameter.init('demo') != 'undefined') {
				__gh__webApp.ads.dfp.loadTestTargeting(testKey,__gh__webApp.utilities.GetURLParameter.init('demo'))
			}
				
				
			__gh__webApp.ads.dfp.loadTestTargeting(testKey,__gh__webApp.utilities.GetURLParameter.init(testKey))
			
		try{ 
		var isUserLoggedIn = __gh__webApp.paywall.isUserLoggedIn(),
			isSubscriber = Krux.segments.indexOf('qjh2j7hcq'),
			thisObject = this;
		}
		catch(e){
			debug.info('Fail __gh__webApp.paywall.isUserLoggedIn.'+e)
		}	
		var kv_lookup = {};
		kv_lookup['~TaxonomyKeywords'] = {value: krux_catlist};
		kv_lookup['~Krux.user'] = {value: Krux.user};
		kv_lookup['~Unknown'] = {value: "Unknown"};	
		/*	
		//Check with Rich. Shoud Krux segment users be marked as subscribers or just logged in users?
		if(isSubscriber !== -1 || isUserLoggedIn !== ""){
			kv_lookup['~Unknown'] = {value: "Subscriber"};
		}
		else{
			kv_lookup['~Unknown'] = {value: "Unknown"};	
		}
		*/
		
		/*
		Below function string page URL paramaters and pass them to DFp as keyword
		Google Policy violation found in Fringe cases where PPI in URL (like email address)
		if(pgtype=='wrapper'){
		
			var url=window.location.href;
			var p = __gh__webApp.common.getURLParts(url)
		    debug.log("p.pathname = "+p.pathname)
		    var urlElements=p.pathname.split('/'),
		    pathKeywords='';
		    
		    $.each(urlElements, function(k, v) {
					 
					try{
					    //debug.info('key = '+k+'. value = '+v+'.') 
					    if(v!=""){ pathKeywords+=v+','; }
					}
					catch(e){
							debug.info('pathkeywords error. '+e)
					}
				 });
				pathKeywords = pathKeywords.slice(0, -1);//remove trailing comma
				kv_lookup['~TaxonomyKeywords'] = {value: krux_catlist+','+pathKeywords};
				//
		}
		*/
		
		if(isSubscriber !== -1 || (isUserLoggedIn !== ""&&isUserLoggedIn !== undefined&&isUserLoggedIn !== false)){
		kv_lookup['~Krux.segments'] = {value: "pntgd7sou,qjh2j7hcq"}; //add Real time segments: Subscriber segments qjh2j7hcq & pntgd7sou
		debug.info("isSubscriber = true");
		} else {
			kv_lookup['~Krux.segments'] = {value: ""}; 
			debug.info("isSubscriber = false");
		}
		
		//add unique id for page
		try{
			kv_lookup['~pageID'] = {value:  __gh__coreData.pageData.profileID};
		}
		catch(e){
			debug.info('pageID undefined  __gh__coreData.pageData.profileID '+e)
		}
		
		//add unique id for article pages
		try{
			if(pgtype=='article'){
				
				var dfp_url = (typeof __gh__coreData.pageData.buckets[0].items.main[0].id !== 'undefined') ?  __gh__coreData.pageData.buckets[0].items.main[0].id : 'null';
				//debug.log('dfp_url= '+__gh__coreData.pageData.buckets[0].items.main[0].id)
				if(typeof(dfp_url) !== 'undefined'){
					kv_lookup['~dfp_url'] = {value: dfp_url}; 	
				}
			}
		}
		catch(e){
			debug.info('dfp_url lookup failed '+e)
		}
		
		
		//pageData.profileID
		try{
			if(typeof(__gh__coreData.globalVariables.ads.keywords) !== 'undefined'){
				//kv_lookup['~TaxonomyKeywords'] = {value: __gh__coreData.globalVariables.ads.keywords};
				if(pgtype=='wrapper'){
					//kv_lookup['~TaxonomyKeywords'] = {value: __gh__coreData.globalVariables.ads.keywords.toString()};
					debug.info("kv_lookup['~TaxonomyKeywords'] = "+kv_lookup['~TaxonomyKeywords'])
				}
			}
		}
		catch(e){
			debug.info('Keyword lookup fail '+e)
		}
			
			
			 //Loop through keys Object @ defaultSlotsJSON.base.keyvalues;
			 googletag.cmd.push(function() {
				 $.each(defaultSlotsJSON.base.keyvalues, function(k, v) {
					 
					try{
					    if(v.charAt(0) == '~') { //check for valuse that need more stuff done
								//debug.info('something needs done'+v)
								//debug.info(v+' lookup = '+kv_lookup[v].value)
								v=kv_lookup[v].value;
						}
					}
					catch(e){
							debug.info('loadBaseTargeting kv_lookup error. '+e)
					}
					
					
					
					//v=thisObject.utilFormatKeyValues(v);
					/*if(__gh__webApp.common.hasString(v,',')){
						var newV='[';
						mySplitResult = v.split(',');
						for(i = 0; i < mySplitResult.length; i++) {
							
							newV += '"'+mySplitResult[i]+'"';
							
							if(i<(mySplitResult.length-1)){
						    	newV += ',';
						    }

						}
						newV += ']';
						
						v=newV;
					}*/
					
					//debug.log("values = "+v)
					
					v=thisObject.utilPiiKeyCheck(k,v);	
				 	googletag.pubads().setTargeting(k, v);
				 	
				 	var type="Page K/V pair";
					thisObject.utilDfpConsole(type,k,v);
				 	
				 });
			 });
		}
		catch(e) {
			debug.info('Error loading DFP base targeting'+e)
		}
	},
	/**
	 * Load Methods
	 */
	"loadTestTargeting": function(k,v) { 
		var thisObject=this;
		try{
			if(v !== undefined) { googletag.cmd.push(function() { 
				v=thisObject.utilPiiKeyCheck(k,v);	
				googletag.pubads().setTargeting(k, v);});
			}
		 }
		 catch(e){
			 debug.info('Error loading test targeting'+e)
		 }
	},
	/**
	 * Load Methods
	 */
	"loadMethods": function() { 
		try{
			googletag.cmd.push(function() { 
			 	googletag.pubads().enableSingleRequest();
			 	googletag.pubads().disableInitialLoad();
			 	googletag.pubads().collapseEmptyDivs();
			 	googletag.enableServices();
			 });
		 }
		 catch(e){
			 debug.info('Error loading DFP methods'+e)
		 }
	}, 
	/**
	 * Load Base Slots
	 */
	"loadBaseSlots": function(pgtype) {
		try{
			//debug.log('loadBaseSlots pgtype= '+pgtype)
			var thisObject=this,
				dfpNameSpace=__gh__webApp.ads.dfp,
				dfpNetworkId=__gh__coreData["3rdPartyData"].ads.dfp.id,
				currentDimensions=[],
				currentId=null,
				dcount=0,
				currentMap=null,
				buildMap=null,
				currentView=null,
				jsonSlotStandard=null,
				jsonSlotsOutOfPage=null,
				interstitialCallback=false,
				interstitialCallbackID=null;
				__gh__coreData.globalVariables.ads.order = __gh__coreData.globalVariables.order || 0;
				
				if(pgtype=='article') {
			  		krux_catlist=dfpNameSpace.defineArticleKeywords();
			  		dfpSecondLevelAdUnit=dfpNameSpace.defineSecondLevel(krux_catlist);
			  		if(dfpSecondLevelAdUnit === false||dfpSecondLevelAdUnit === undefined) {dfpSecondLevelAdUnit='/news'} //for no taxonomy. Ryan attention does removed from
		  		}
		  		
		  		var dfpAdUnitFull='/'+dfpNetworkId+'/'+dfpFirstLevelAdUnit+dfpSecondLevelAdUnit;
		  		
		  		var type="Ad Unit",
		  			k="";
					thisObject.utilDfpConsole(type,k,dfpAdUnitFull)

			googletag.cmd.push(function() {
				
				
			 jsonSlotStandard=defaultSlotsJSON.base.slots.standard;
			 jsonSlotsOutOfPage=defaultSlotsJSON.base.slots['rich media'];
			 
			 if(jsonSlotStandard !== undefined) {
				 
				 $.each(jsonSlotStandard, function(slotName, item) {
					/*if(thisObject.checkDiv(slotName) === false){
						Race condition with baseMedRec (or any div) not on page when this fires
						debug.log('div does not exsist'+slotName)
						//continue;
					}*/
					 
					currentId=defaultSlotsJSON.base.slots.standard[slotName].id,
					dcount=0,
					currentDimensions=[],
					currentDimensionItem=[],
					currentDimentionL=defaultSlotsJSON.base.slots.standard[slotName].dimensions.length,
					jsonDimensions=defaultSlotsJSON.base.slots.standard[slotName].dimensions,
					jsonKeyValues=defaultSlotsJSON.base.slots.standard[slotName].keyvalues;
					__gh__webApp.ads.dfp.slotNames.push(slotName);
	
					 //Define Standard Slot Dimensions
				    $.each(jsonDimensions, function(d, ditem) {
					    currentDimensionItem.push(ditem.size.w)
						currentDimensionItem.push(ditem.size.h)
						currentDimensions.push(currentDimensionItem);
					  	
					  	dcount+=1;
				    });
					//console.log("---> currentDimensions= ",currentDimensions)
				    
				    var type="Standard Slot",
				    k=slotName;
				    thisObject.utilDfpConsole(type,k,currentDimensions)
				     
				    //Define Slot
				    //gptAdSlots[currentId].slotname
					gptAdSlots[currentId]=googletag.defineSlot(dfpAdUnitFull, currentDimensions, slotName).addService(googletag.pubads());
					
					currentMap=$('#'+slotName).attr('data-size-mapping');
					
					if(currentMap!=undefined) {
					    buildMap=googletag.sizeMapping();
					    
					    $.each(dfpMaps.map[currentMap], function(view, item) {
						    currentView=dfpMaps.map[currentMap][view];
						    
				    		//Build current slot sizeMapping
						    //debug.info("currentView.ad_sizes="+currentView.ad_sizes);
							buildMap.addSize(currentView.viewport, currentView.ad_sizes);
							
						var type="Mapping",
						k=slotName,
						v='Viewport = '+currentView.viewport+'. Size Mappings = '+currentView.ad_sizes;
						thisObject.utilDfpConsole(type,k,v)
							
						});
						//Add Mapping to current Slot
						gptAdSlots[currentId].defineSizeMapping(buildMap.build());

					}

				    //Define Standard Slot Key Values
				    $.each(jsonKeyValues, function(k, v) {
					    if(dfpNameSpace.utilKeyLength(k,v)){
	
						v=thisObject.keyValuePairShim(k,v,'pink',krux_catlist,'pink');
						
						//v=thisObject.utilFormatKeyValues(v);
						var type="Slot K/V pair";
						thisObject.utilDfpConsole(type,k,v)
						v=thisObject.utilPiiKeyCheck(k,v);	
						gptAdSlots[currentId].setTargeting(k, v); 
						
						if(k=='order'){__gh__coreData.globalVariables.order=v;}//used to set value of key = order in defineSlot()
					  			
					  	}
				     });
				     
				     
				    if(pgtype=='article') { 
					    var k='keyword';
					    krux_catlist=thisObject.utilPiiKeyCheck(k,krux_catlist);	
					    gptAdSlots[currentId].setTargeting(k, krux_catlist); thisObject.utilDfpConsole(type='Slot K/V pair',k='keyword',krux_catlist) 
					}

					headertag.display(slotName);
	
				  });
			  }
			  
			  if(jsonSlotsOutOfPage !== undefined) {
				  $.each(jsonSlotsOutOfPage, function(slotName, item) {
					currentId=jsonSlotsOutOfPage[slotName].id,
					dcount=0;
					__gh__webApp.ads.dfp.slotNames.push(slotName);
				    
				    var type="OutofPage Slot",
				    k=slotName,
				    currentDimensions='1,1';
				    thisObject.utilDfpConsole(type,k,currentDimensions)
	
				    //Define current Out of page slot
				    gptAdSlots[currentId]=googletag.defineOutOfPageSlot(dfpAdUnitFull, slotName).addService(googletag.pubads());
				    
				    try{
					    //Define Rich Media Key Values
				        $.each(jsonSlotsOutOfPage[slotName].keyvalues, function(k, v) {
					        if(dfpNameSpace.utilKeyLength(k,v)){
						        
						        var type="Slot K/V pair";
								
								v=thisObject.keyValuePairShim(k,v,'pink',krux_catlist,'pink');
								v=thisObject.utilPiiKeyCheck(k,v);	
								thisObject.utilDfpConsole(type,k,v)
						  		gptAdSlots[currentId].setTargeting(k, v);
						  	}
					     });
					     
					     if(pgtype=='article') { 
						     var k='keyword';
						     krux_catlist=thisObject.utilPiiKeyCheck(k,krux_catlist);	
						     gptAdSlots[currentId].setTargeting(k, krux_catlist); thisObject.utilDfpConsole(type='Slot K/V pair',k='keyword',krux_catlist)
						 }
				     }
				     catch(e){
					     debug.info("Error Defining Rich Media Key Values"+e)
				     }

				     
				    var appendID='footer-main';
				    if(slotName=='slidingBillboard') {
					    appendID='header-content';
					    try{dfpNameSpace.collapseSlot(currentId,slotName);}catch(e){debug.info("Collapse fail. "+slotName);} //collaspe div
					}

				    dfpNameSpace.createDiv(slotName,appendID,sizeMapping=''); 
				    
					//Interstital checks for callback / bind to Lightbox events
					if(slotName=='interstitial'){
						interstitialCallback=true;
						interstitialCallbackID=gptAdSlots[jsonSlotsOutOfPage['interstitial'].id];
				    }
				    else {
					    headertag.display(slotName); //Display slot 
				    }
	
				  });
			  }
			  
			  if(jsonSlotStandard !== undefined || jsonSlotsOutOfPage !== undefined){
				  if(interstitialCallback==true){
					apstag.setDisplayBids();
					headertag.pubads().refresh([gptAdSlots[0]]); //fetch all base slots, minus interstitial (gptAdSlots[2] on articles)

					var offerCallbackObject = {
							"callback": function(slotID){
								headertag.display('interstitial'); //Display slot on press+ article pages if paywall lightbox will not open
								debug.info("[Interstital DFP Slot] DISPLAY: article page.");
								headertag.pubads().refresh([slotID]); //refresh interstitial slot
							},
							"data": interstitialCallbackID
						};
						
					__gh__webApp.paywall.offerCallback({
						"showOfferCallbackObject": false,
						"noOfferCallbackObject": offerCallbackObject,
						"isDisabledCallbackObject": offerCallbackObject
					});
					
					
				  }
				  else{
					apstag.setDisplayBids();
					headertag.pubads().refresh(); //fetch all base slots  
				  }
			  }
			  
			  if(jsonSlotStandard === undefined && jsonSlotsOutOfPage === undefined && __gh__coreData.globalVariables.ads.dfpTemplateType!='native'){
				  __gh__webApp.ads.dfp.isLoaded=true;
				 __gh__webApp.ads.dfp.callbackFunction();
				 debug.log('no base slot defined')
			  }
			  
			  return true;
			});  
			

		}
		catch(e){
			debug.info('Error loading base slots'+e)
			return false;
		}
	},
	
	/**
	 * Generate Slot name for lazy loading ads
	 */
	"generateSlotName": function() { 
		try{
			var id = gptAdSlots.length+1;
			return 'glazyAd-'+id;
		}
		catch(e){
			 debug.info('Error generating slot name. '+e)
		}
	}, 
	
	/**
	 * Create New DFP Slots
	 */
	"createLazySlot": function(container,slotType) { 
		try{
			var container = (typeof container !== 'undefined') ?  container : '.ad-lazy',
				slotType  = (typeof slotType !== 'undefined') ?  slotType : 'View PLus',
				$myAd=$(container).first(),
				slotName=($myAd.attr('id') !== undefined&&__gh__webApp.ads.dfp.slotNames.indexOf($myAd.attr('id'))==-1) ? $myAd.attr('id') : __gh__webApp.ads.dfp.generateSlotName(),
				slot={slotName:slotName,slotType:slotType};
				
			__gh__webApp.ads.dfp.slotNames.push(slotName);
				
			//debug.log("slotName="+slotName)
			//debug.log("slotType="+slotType)
				
			if(slotName!==$myAd.attr('id'))	{
				$myAd.attr('id', slotName);
			}
			__gh__webApp.ads.dfp.defineSlot(slot);
			$myAd.removeClass( container.replace('.','') ); // remove ad-lazy class so the ad does not get processed again
		 }
		 catch(e){
			 debug.info('Error creating slot'+e)
		 }
	}, 
	/**
	 * Check if Div with DFP ID exsits to target.
	 */
	"checkDiv": function(slotName) { 
		try{
				var myAdElem = document.getElementById(slotName);
					
				if (myAdElem === null) {
						debug.warn("Warning: Element with div ID= "+slotName+" does not exsist. Ad slot not being called.")
						
						return false;
				}
				else{
					return true;
				}
		 }
		 catch(e){
			 debug.info('Error checking for div ID for slot '+slotName+'. '+e);
			 return false;
		 }
	}, 
	/**
	 * Create Div for DFP Slots
	 */
	"createDiv": function(slotName,appendID,sizeMapping) { 
		try{
				var myAdElem = document.getElementById(slotName),
					myElem = document.getElementById(appendID);
					
				if (myAdElem === null) {
					if (myElem === null) {
						debug.warn("Warning: Element with ID= "+appendID+" does not exsist. Adding it.")
						
						var featuredDiv = document.createElement('div'),
						el2=document.getElementById("content");
						
						featuredDiv.id = appendID; // Id must be the same as slotName
						el2.insertBefore(featuredDiv,el2.firstChild); //add to dom
					}
					
					//Create div on the fly for ad unit
					var slotDiv=slotDiv = document.createElement('div'),
					el=document.getElementById(appendID);
					
					   // Create a div for the slot
					   slotDiv.id = slotName; // Id must be the same as slotName
					   if(sizeMapping!=''){
						   var att = document.createAttribute("data-size-mapping");       // Create a "data-size-mapping" attribute
							att.value = sizeMapping;                           // Set the value of the data-size-mapping attribute
							slotDiv.setAttributeNode(att);
					   }
					   el.insertBefore(slotDiv,el.firstChild); //add to dom
					   $('#'+slotName).addClass('ad text-center'); 
					return true;
				}
				else{
					debug.warn("Warning: DFP div with ID= "+slotName+" already exsist. Not adding it.")
					return false;
				}
		 }
		 catch(e){
			 debug.info('Error creating div for slot '+slotName+'. '+e);
			 return false;
		 }
	}, 
	
	
	/**
	 * Define Slots
	 */
	"defineSlot": function(slot) {
		try{
			var thisObject=this;

			googletag.cmd.push(function() {
				var slotName=slot.slotName,
				slotType  = (typeof slot.slotType !== 'undefined') ?  slot.slotType : 'View PLus',
				dfpNameSpace=__gh__webApp.ads.dfp,
				dfpNetworkId=__gh__coreData["3rdPartyData"].ads.dfp.id,
				$adUnit =$('#'+slotName),
				targeting=$adUnit.attr('data-targeting'),
				currentMap=$adUnit.attr('data-size-mapping'),
				dfpID=gptAdSlots.length,
				gptAdSlotsLazy=[],
				dfpAdUnitFull='/'+dfpNetworkId+'/'+dfpFirstLevelAdUnit+dfpSecondLevelAdUnit,
				slotsForBids=[],
				adType=thisObject.checkType(slotName),
				currentView=undefined,
				sizeMappings=[];
				debug.log("DefineSlot= "+slotName)
				debug.log("adType= "+adType)

				if(typeof(adType)=='string'&&adType!=false){
					adType=adType.toLowerCase();
				}
				else{
					adType == 'unknown';
				}

				if(adType == 'rich media'){
					var type=adType,
				    k=slotName;
				    try{thisObject.utilDfpConsole(type,k,dimensions)}catch(e){debug.info('Fail outputing log'+e)}

					gptAdSlots[dfpID]=googletag.defineOutOfPageSlot(dfpAdUnitFull, slotName).addService(googletag.pubads());
					
					
					
					// Sets custom targeting for THIS slot
					try{
	                    var targeting = $adUnit.data('gh-lazy-ad-bucket-targeting');
	                    //console.log("targeting=",targeting)
	                    if (targeting) {
	                        $.each(targeting, function (k, v) {
		                        var keyValueLength= v.length,
		                        currentPage 	   = __gh__webApp.currentPage;
						    	//add krux_catlist to section slot keywords as slot level keyword trump page level keywords. ie pearl harbor
						    	if(k==='keyword'&&keyValueLength>0&&currentPage.isSectionStandard()||currentPage.isSectionEnhanced()||currentPage.isSectionBasic()||currentPage.isImageDriven()||currentPage.is101Things()){
									v=v+','+krux_catlist;
							    }
	
							    if(dfpNameSpace.utilKeyLength(k,v)){
									v=thisObject.utilPiiKeyCheck(k,v);	
									thisObject.utilDfpConsole(type,k,v)
									gptAdSlots[dfpID].setTargeting(k, v);	
						  		}
							    
	                        });
	                    }
	                   // __gh__coreData.globalVariables.order = parseInt(__gh__coreData.globalVariables.order,10)+1 || 1;
	                    var type="Slot K/V pair";
	                    k='order'
					    v=__gh__coreData.globalVariables.order;
					    gptAdSlots[dfpID].setTargeting(k, v);
					    thisObject.utilDfpConsole(type,k,v)
	                    
					}
					catch(e){
						debug.info('target fail'+e)
					}
					
					
					
					
					__gh__webApp.ads.dfp.renderSlot(dfpID,slotName);
					
				}else{
					var dimensions=$adUnit.attr('data-dimensions'),
						re = /(\[|\])/g,
						newD=dimensions.replace(re,'').split(','),
						type="Standard Slot",
						k=slotName;
				    try{thisObject.utilDfpConsole(type,k,dimensions)}catch(e){debug.info('Fail outputing log'+e)}

				    slotsForBids[0]={slotID:slotName,sizes:[]}
					try{
					    //Mappings for bids   
						if(currentMap!=undefined) {
						    buildMap=googletag.sizeMapping();
						    $.each(dfpMaps.map[currentMap], function(view, item) {
							    currentView=dfpMaps.map[currentMap][view];
							    //debug.info("currentView.ad_sizes="+currentView.ad_sizes);
							    //debug.info("currentView.viewport="+currentView.viewport);
							    
							    var type="Mapping",
									k=slotName,
									v='Viewport = '+currentView.viewport+'. Size Mappings = '+currentView.ad_sizes;
								thisObject.utilDfpConsole(type,k,v)
							    //Build slot sizeMapping
								buildMap.addSize(currentView.viewport, currentView.ad_sizes);
								//Add to sizeMapping for APS bids (amazon)
								sizeMappings.push([currentView.viewport, currentView.ad_sizes])
							});
							var validMappings=__gh__webApp.utilities.parseSizeMappings(sizeMappings);
							//console.log("sizeMappings=",sizeMappings);
							//console.log("validMappings=",validMappings);
							//console.log("validMappings.length=",validMappings.length);
							if(validMappings.length > 0){
								slotsForBids[0].sizes=validMappings
							}
							else{ 
								slotsForBids.pop(); 
								__gh__coreData.globalVariables.ads.lazyAdsLoading=__gh__coreData.globalVariables.ads.lazyAdsLoading-1; 
								gptAdSlots[dfpID]=[];
								return;
							}//either there are valid mappings OR don't continue as there are no slot sizes
						} 
						else{
						    var dcount=0,
						    	dLength=newD.length;
							while (dcount < dLength) {
								slotsForBids[0].sizes.push([parseInt(newD[dcount], 10),parseInt(newD[dcount+1], 10)]);
								dcount+=2;
							}
						}
					} catch(e){
						debug.log("error defining lazy mappings"+e)
					}
					gptAdSlots[dfpID]=googletag.defineSlot(dfpAdUnitFull, slotsForBids[0].sizes, slotName).addService(googletag.pubads());
					if(currentMap!=undefined) {gptAdSlots[dfpID].defineSizeMapping(buildMap.build());} //add mapping to defined slot
					
					// Sets custom targeting for THIS slot
					try{
	                    var targeting = $adUnit.data('gh-lazy-ad-bucket-targeting');
	                    //console.log("targeting=",targeting)
	                    if (targeting) {
	                        $.each(targeting, function (k, v) {
		                        var keyValueLength= v.length,
		                        currentPage 	   = __gh__webApp.currentPage;
						    	//add krux_catlist to section slot keywords as slot level keyword trump page level keywords. ie pearl harbor
						    	if(k==='keyword'&&keyValueLength>0&&currentPage.isSectionStandard()||currentPage.isSectionEnhanced()||currentPage.isSectionBasic()||currentPage.isImageDriven()||currentPage.is101Things()){
									v=v+','+krux_catlist;
							    }
	
							    if(dfpNameSpace.utilKeyLength(k,v)){
								    var type="Slot K/V pair";
									v=thisObject.slotTypeShim(k,v,slotType,dimensions);
									v=thisObject.keyValuePairShim(k,v,'pink',krux_catlist,'pink');
									v=thisObject.utilPiiKeyCheck(k,v);	
									thisObject.utilDfpConsole(type,k,v)
									gptAdSlots[dfpID].setTargeting(k, v);	
						  		}
							    
	                        });
	                    }
	                    __gh__coreData.globalVariables.order = parseInt(__gh__coreData.globalVariables.order,10)+1 || 1;
	                    var type="Slot K/V pair";
	                    k='order'
					    v=__gh__coreData.globalVariables.order;
					    gptAdSlots[dfpID].setTargeting(k, v);
					    thisObject.utilDfpConsole(type,k,v)
	                    
					}
					catch(e){
						debug.info('target fail'+e)
					}
					
					try{
	                    if (__gh__coreData.globalVariables.ads.dfpTemplateType=='native') {   
		                        k='articleKey';
		                        v = (typeof __gh__coreData.globalVariables.ads.articleKey !== 'undefined') ?  __gh__coreData.globalVariables.ads.articleKey : '';
								    var type="Slot K/V pair";
									thisObject.utilDfpConsole(type,k,v)
									v=thisObject.utilPiiKeyCheck(k,v);	
									gptAdSlots[dfpID].setTargeting(k, v);	
	                    }
	                 }
	                 catch(e){
						debug.info('Native target fail. '+e)
					}

					__gh__webApp.ads.amazonHeader.fetchLazyBid(slotsForBids,dfpID,slotName);
			}	
				
				__gh__coreData.globalVariables.ads.lazyAdsLoading=__gh__coreData.globalVariables.ads.lazyAdsLoading-1;	
				return;
			});	
		}
		catch(e){
			debug.info('Error defining DFP slot'+e);
		}

	},
	/**
	 * Define section Leve ad units base on keywords
	 * Looks though krux_catlist and using first taxonomy match found for second level ad unit
	 */
	"defineSecondLevel": function(krux_catlist) {
		try{

			var dfpSecondLevelAdUnit,
				taxo_split = krux_catlist.split(','),
				dfpTaxoMap=__gh__webApp.ads.dfp.taxonomyMap.taxonomy;
				debug.log('taxo_split ='+taxo_split[0])
			
			try{
				var profileAdCode = __gh__coreData.pageData.buckets[0].adCode;
				if(profileAdCode!==""&&__gh__coreData.pageData.buckets[0].adCode!=undefined){
				    //dfpSecondLevelAdUnit='/'+dfpTaxoMap[profileAdCode];
				    //debug.log('inProfile dfpSecondLevelAdUnit='+dfpSecondLevelAdUnit)
				    return profileAdCode; 
			    }
			    /*
				//if we want to try and control what is input into the profile.. no third level support
			    var profileAdCode = __gh__coreData.pageData.buckets[0].adCode.substr(1);
				if(dfpTaxoMap[profileAdCode] !== undefined){
				    dfpSecondLevelAdUnit='/'+dfpTaxoMap[profileAdCode];
				    //debug.log('inArray dfpSecondLevelAdUnit='+dfpSecondLevelAdUnit)
				    return dfpSecondLevelAdUnit; 
			    }
			    */

			}
			catch(e){
				debug.log("Error on profileAdCode.= "+e)
			}
			
			$.each(taxo_split, function(k, v) {
			    //debug.log('key='+k+'; value='+v+';')
			    //debug.log('index check '+dfpTaxoMap[v])
			    
			    if(dfpTaxoMap[v] !== undefined){
				    dfpSecondLevelAdUnit='/'+dfpTaxoMap[v];
				    debug.log('inArray dfpSecondLevelAdUnit='+dfpSecondLevelAdUnit)
				    return false; //break each loop
			    }
			     
			}); 
			
			if(dfpSecondLevelAdUnit==''||dfpSecondLevelAdUnit===undefined) {dfpSecondLevelAdUnit='/news'; debug.info('default to /news')}
			return dfpSecondLevelAdUnit;
		}
		catch(e){
			debug.error('Defining DFP Second Level Ad unit failed. '+e);
			return false;
		}
	},

	/**
	 * Render Slots
	 */
	"renderSlot": function(n,slotName) {
		try{
		   googletag.cmd.push(function() {
				try {
					headertag.display(slotName);
					headertag.pubads().refresh([gptAdSlots[n]]);
				}
				catch (e) {
					// statements to handle any exceptions
					debug.info(slotName+' dynamic slot failed'); // pass exception object to error handler
				}
	
		   });
		}
		catch(e){
			debug.info('Error rendering lazy slot'+e);
		}
	},

	/**
	 * Collapse Slots
	 */
	"collapseSlot": function(currentId,slotName) {
		try{
			// Collapse Slots
			//setCollapseEmptyDiv(collapse, opt_collapseBeforeAdFetch)
			// The below will cause the div for this slot to be collapsed
			// when the page is loaded, before the ads are requested
		   googletag.cmd.push(function() {
		
			     // Collapse
				try {
					gptAdSlots[currentId].setCollapseEmptyDiv(true, true);
					//debug.info(slotName+' collapse slot. For currentId='+currentId); // pass exception object to error handler
				}
				catch (e) {
					// statements to handle any exceptions
					debug.info(slotName+' collapse slot failed'); // pass exception object to error handler
				}

		   });
		}
		catch(e){
			debug.info('Error collaping slot'+e);
		}
		
	},
	/**
	 * Base Ad Section Shim
	 */
	"baseAdShim": function(slotName,shimClass,updateTrigger) {
		try{ 
			//debug.log('shim slotName'+slotName)
			//shimClass= ad-lazy
			//var shimClass = 'ad-lazy'
			var $myAd=$( '.'+shimClass).first();

			$myAd.filter("[data-size-mapping='baseLeaderboard']");
			
			//do nothing if this is a leaderboard or it will attached the wrong keyvalues to baseMedRec
			if($myAd.filter("[data-size-mapping='baseLeaderboard']").length == 1){return;}
			
			
				$myAd.attr('id', slotName);
			//debug.log('$myAd'+$myAd)	
				if(slotName === 'baseLeaderboard'||slotName === 'baseLeaderBillboard'){ 
					$myAd.attr('data-size-mapping', slotName); 
					$myAd.parent( ".inner" ).removeClass( "inner");
				}
				//RYAN look at why this isn't working $myAd.removeClass( shimClass )
				
				if(updateTrigger===true) {
					var $loadAd = $("[data-gh-lazy-ad-loaded=false]").first();
					$loadAd.attr("data-gh-lazy-ad-loaded",true);
				}
				$myAd.removeClass( shimClass ); // remove ad-lazy class so the ad does not get processed again
				//$myAd.removeClass( "ad-lazy" ); // remove ad-lazy class so the ad does not get processed again

				return;
		}
		catch(e) {
			debug.info('Error building section shim '+e)
			return;
		}
	},
	/**
	 * Key Value Pair  Shim
	 */
	"keyValuePairShim": function(k,v,needle,haystack,vUpdate) {
		try{
			//debug.log('v=== '+v)
			if(k==='sov'&&v.toLowerCase()!=='standalone'){
				
				if(haystack.split(',').indexOf(needle) > -1 ) {
				   // found
				  // debug.log('found sov');
				   v=vUpdate;
				}    
				//debug.log('v=== '+v)
			    //debug.log('krux catlist=== '+krux_catlist)
		    }
		    
		    
		    if(k==='sov'&&v.toLowerCase()==='standalone'){

				   //debug.log('found standalone');
				   v='base ROS';
				//debug.log('v=== '+v)
			    //debug.log('krux catlist=== '+krux_catlist)
		    }
				return v;
		}
		catch(e) {
			debug.info('Error building Key Value Pair shim '+e)
			return;
		}
	},
	/**
	 * Slot Type  Shim
	 * Base ad Shim for lazy slots
	 */
	"slotTypeShim": function(k,v,slotType,dimensions) {
		try{
		    if(k==='slot'&&slotType==='Base'){

				if(dimensions.indexOf('300')!=-1){
					v='Base Med Rec';
				}
				
				if(dimensions.indexOf('728')!=-1){
					v='Base Leaderboard';
				}
				debug.log("slotOverride = "+v)
		    }
			return v;
		}
		catch(e) {
			debug.info('Error building Slot Type shim '+e)
			return v;
		}
	},
	/**
	 * Define Article Keywords to pass to ad slots
	 */
	"defineArticleKeywords": function() {
		try {
			//Ryan attention. Chris combined these in one.
			//add article taxomomies 
			//Grab Article Data feed URL to get Taxonomy
			var articleJsonURL = __gh__coreData.pageData.buckets[0].feedURL //Grab informaiton for the first article
			//Ryan attention. Instead of grapping this URL and fetching feed URL agian. Can this data be grabbed from __gh__coreData.pageData.buckets[0].main.items?
			//1 needs to be a variable that tells me what the current aritcle we are on is
			var dfpNameSpace=__gh__webApp.ads.dfp,
				articleJson= __gh__webApp.utilities.fetch.json.get({"url": articleJsonURL}),
				articleKeywords = articleJson.main[0].keywords,
				articleTaxonomy = articleJson.main[0].taxonomy,
				articleGUID		= articleJson.main[0].guid,
				keywordList='';
			
			if(articleKeywords !== undefined) {
				$.each(articleKeywords, function(k, v) {
					if(dfpNameSpace.utilKeyLength(k,v)){ keywordList+=v.trim()+','; }	
				});
			}
			
			if(articleTaxonomy !== undefined) {
				$.each(articleTaxonomy, function(k, v) {
					//debug.info("============================== value= "+v)
					if(dfpNameSpace.utilKeyLength(k,v)) { keywordList+=v.trim()+','; }
				});
			}
			
			keywordList = keywordList.slice(0, -1);//remove trailing comma
			keywordList=keywordList.toLowerCase();
			
			//debug.info('ARticle keyword list_____----->= '+keywordList);
			__gh__coreData.globalVariables.ads.keywords=keywordList;
			return keywordList;
			}
		catch(e){
			debug.info('Article keyword fail. '+e)
		}
	},
	
	/**
	 * Key Lenth Utility Checker
	 */
	"utilKeyLength": function(k,v) {
		try{ 
			
			//
			var keyValueLength;
			if(k==='keyword'||k==='creative-format') {
				var vSplit=v.split(',')
				for(var i = 0; i < vSplit.length; i++) {
				   // Add additional code here, such as:
				   keyValueLength= vSplit[i].length;
				   //debug.log('vSplit[i]='+vSplit[i])
				    if(keyValueLength <= 40){
					    //donothing to keep looping through
					}
				  	else {
					  	debug.warn('Keyword Warning: Key='+k+'. Value length > 40 chars @ '+keyValueLength+' not used. Value='+v);
					  	return false;
				  	}
				}
				//if we made it though the loop, return true as keyword lengths are fine
				return true;
			}			
			else {
					keyValueLength= v.length;
				    if(keyValueLength <= 40){ return true;}
				  	else {
					  	debug.warn('Warning: Key='+k+'. Value length > 40 chars @ '+keyValueLength+' not used. Value='+v);
					  	return false;
				  	}
				
			}
			
			

		}
		catch(e) {
			debug.info('Error checking key value length. '+e)
			return;
		}
	},
	/**
	 * topBarSponsor
	 */
	"triggerSlot": function(container) { 
		try{
			
			__gh__webApp.ads.dfp.createLazySlot(container);	
		 }
		 catch(e){
			 debug.info('Error on triggerSlot(). '+e)
		 }
	},
	/**
	 * Output DFP Debug Utility
	 */
	"utilDfpConsole": function(type,k,v) { 
		try{
			var debugKey='dfpconsole';
			if(__gh__webApp.utilities.GetURLParameter.init(debugKey)){
				if(type=='Page K/V pair'||type=='Slot K/V pair'){
					debug.info('DFP--> '+type+": key="+k+". value="+v)
				}else if(type=='Standard Slot'||type=='OutofPage Slot'){
					debug.info('DFP--------------> '+type+": slot="+k+". dimensions="+v+"<--------------")
				}else{
					debug.info('DFP--> '+type+": value="+v)
				}
					
			}	
		 }
		 catch(e){
			 debug.info('Error Outputing DFP Debug data. '+e)
		 }
	},
	/**
	 * Utility to manage laying down new ads based on page and div elements by id or class
	 */
	"utilCheckLayNewAds": function(dfpSecondLevel) { 
		try{

debug.log('dfpSecondLevel = '+dfpSecondLevel)
			/*if(dfpSecondLevel=='/jobs'){
				this.utilLayNewAds(innerContainer='#content',rightContainer='.ad-container', adMarginTop=450)
			}
			
			if(dfpSecondLevel=='/contests'||dfpSecondLevel=='/contests/contest'){
				this.utilLayNewAds(innerContainer='.inner',rightContainer='.rightbar', adMarginTop=600)
			}*/
			
			if(dfpSecondLevel=='/classifieds'){
				this.utilLayNewAds(innerContainer='.col-md-8',rightContainer='#dfpAds', adMarginTop=600)
			}
			
			if(dfpSecondLevel=='/auto'){
				this.utilLayNewAds(innerContainer='#content',rightContainer='.ad-container', adMarginTop=600)
			}

		 }
		 catch(e){
			 debug.info('Error Checking to Lay down New Ads. '+e)
		 }
	},
	/**
	 * Utility to lay down new ad positioin in a right rail if space if available
	 */
	"utilLayNewAds": function(innerContainer,rightContainer,adMarginTop) { 
		try{
			var w = $(window).width();
			if( w > 990 ){
				function setNewAds(adMarginTop){	
					
					$('.newRailAds').remove(); // remove all ads on the page
					
					var innerHeight		= $(innerContainer).height(), // grab height on left column
						rightbarHeight	= $(rightContainer).height(),  // grab height of right column
						newAdSpace		= innerHeight - rightbarHeight,  // amount of real estate in right rail
						adHeight		= 250, //height of ad
						adSpace			= adHeight+adMarginTop, // amount of space one ad will take up.  250px + 600px padding
						numAds 			= Math.floor(newAdSpace/adSpace);  // number of ads that will fit in the extra space
						
						debug.log("==========================");
						debug.log("==========================");
						
						debug.log('innerHeight: '+innerHeight);	
						debug.log('rightbarHeight: '+rightbarHeight);	
						debug.log('adSpace: '+adSpace);
						debug.log('newAdSpace: '+newAdSpace);

						
						if (numAds > 0){
							
							debug.log("Number of ads we can add: "+numAds);
							
							for (i = 0; i < numAds; i++) { 
								var templ = '<div class="newRailAds" style="margin-top: '+adMarginTop+'px;" data-gh-lazy-ad-loaded="false"><div class="ad ad-lazy" data-gh-lazy-ad-bucket-targeting=\'{"ad-type":"standard","slot":"View Plus Med Rec","sov":"Standalone"}\'  data-dimensions="[300,250]"></div></div>';
								$(rightContainer).append(templ);
							}
							
						} else {
							debug.log('No extra ads can be drawn.');
						}
						
						debug.log("==========================");
						debug.log("==========================");
				}	
				
				
				/*
					 * Wait for all elements on the page to render
				 * 
				 *
				 *
				 */
				setTimeout(function(){ 
					setNewAds(adMarginTop);
				}, 2000);	


				/*
				* Detect a change in the URL.
				*  For example, if a user Filters content
				*  recalculate the white space in the right rail 
				*
				*
				*/
				var oldLocation = location.href;
				setInterval(function() {
					if(location.href != oldLocation) {
						// do your action
						setNewAds(adMarginTop);
						debug.log("URL has changed")
						oldLocation = location.href
					}
				}, 1000); // check every second
				
			} // end window.width
		 }
		 catch(e){
			 debug.info('Error Laying New Ads. '+e)
		 }
	},
	/**
	 * Check URL for Personal Info. Kill ad requests if found.
	 */
	"utilPiiCheck": function() {
		try{ 
			
			var url=window.location.href;
			var p = __gh__webApp.common.getURLParts(url)
		    
		    if(__gh__webApp.common.hasString(p.pathname,'@')||__gh__webApp.common.hasString(p.search,'@')){
			    debug.info('Pii in URL')
			    return true;
		    }
		    
		    if(__gh__webApp.common.hasString(p.pathname,'%40')||__gh__webApp.common.hasString(p.search,'%40')){
			     debug.info('Pii in URL')
			    return true;
		    }
			return false;

		}
		catch(e) {
			debug.info('Error checking URL for pii. '+e)
			return false;
		}
	},
	/**
	 * Check for Personal Info. Scrub if found
	 */
	"utilPiiKeyCheck": function(k,v) {
		try{ 
		    (typeof v !== 'undefined') ?  v : '';
		    if(__gh__webApp.common.hasString(v,'@')||__gh__webApp.common.hasString(v,'%40')){
			    debug.info('Pii in value removing values');
			    v='';
			    return v;
		    }
		    
			return v;

		}
		catch(e) {
			debug.info('Error checking for pii in key='+k+'. value='+v+'. error= '+e)
			return false;
		}
	},
	/**
	 * Format Key Values  with multiple values
	 */
	"utilFormatKeyValues": function(v) {
		//not sure this is actually needed
		try{ 
			if(__gh__webApp.common.hasString(v,',')){
						var newV='';
						mySplitResult = v.split(',');
						for(i = 0; i < mySplitResult.length; i++) {
							
							newV += '"'+mySplitResult[i]+'"';
							
							if(i<(mySplitResult.length-1)){
						    	newV += ',';
						    }

						}
						return newV;
			}
			else{
				return v;
			}
		}
		catch(e) {
			debug.info('Error utilFormatKeyValues. '+e)
			return v;
		}
	}, 
	/**
	 * Build Map Targeting
	 */
	"buildMapping": function(currentMap) {
		try{ 
			googletag.cmd.push(function() {
				var dpfMapping=googletag.sizeMapping(),
					//mapURL = "http://redesign.gatehousemedia.com/master/assets/json/dfp/dfpMaps.json",
					//dfpMaps   = __gh__webApp.utilities.fetch.json.get({"url": mapURL}),
					currentView=null;

				$.each(dfpMaps.map[currentMap], function(view, item) {
				    currentView=dfpMaps.map[currentMap][view];
					//Build current slot sizeMapping
				    debug.info("currentView.ad_sizes="+currentView.ad_sizes);
					dpfMapping.addSize(currentView.viewport, currentView.ad_sizes);
				}); 
				
				return dpfMapping;
			});
							/*
				try{
				    if(currentMap!=undefined) {
						buildMap= __gh__webApp.ads.dfp.buildMapping(currentMap);
						debug.info(buildMap)
						//Add Mapping to current Slot
						gptAdSlots[currentId].defineSizeMapping(buildMap.build());
					}
				}
				catch(e){
					debug.info('Build map failed')
				}
				*/
			
		}
		catch(e) {
			debug.info('Error building map'+e)
			return;
		}
	},
	/**
	 * Build krux_catlist
	 */
	"buildKruxCatlist": function(k,v,o) {
		try{ 
			
			if(k == 'article keywords'){ //add keywords to list for krux if it does not already exsist
				v=JSON.stringify(v);
				
				v=v.replace('[','');
				v=v.replace(']','');
				v=v.replace('"','');
				v=v.replace(/\"/g, '')
				k == 'keyword'
			}
			//var vSplit=v.split(',')
			//if(k == 'keyword'&&krux_catlist.indexOf(v.toLowerCase()) === -1){ //add keywords to list for krux if it does not already exsist
			
			
				
				   if(k.substring(0,1) == ','){
					   k = k.replace(/^,/, '');
				   }
				   
				   if(o == 'add'){
					   
					   if(krux_catlist.length === 0) {
					   	   krux_catlist = v.toLowerCase();
					   }
					   else{
						   krux_catlist += ','+v.toLowerCase();
						   
						   var uniqueList=krux_catlist.split(',').filter(function(item,i,allItems){
							    return i==allItems.indexOf(item);
							}).join(',');
							
							//debug.log('uniqueList='+uniqueList)
							krux_catlist=uniqueList; 
					   }
				   
				   }
				   else {
					 	krux_catlist = v.toLowerCase();  
				   }
				   
				   krux_catlist=krux_catlist.replace(/(^\s*,)|(,\s*$)/g, ''); //strip trailing comma


			//debug.log('krux_catlist='+krux_catlist)
			return true;
			
		}
		catch(e) {
			debug.info('Error building buildKruxCatlist'+e)
			return;
		}
	},
	
	/**
	 * Slots Rendered 
	 * fires off after each slot is rendered. Specific slot need chosen if needed
	 */
	"eventSlotsRendered": function() {
		try {
			googletag.cmd.push(function() {
				googletag.pubads().addEventListener('slotRenderEnded', function(event) {
				
				__gh__webApp.ads.dfp.isLoaded=true;
				__gh__webApp.ads.dfp.callbackFunction();
				//load lazy ads after first ad renders
				if(event.slot === gptAdSlots[0]){
					//debug.info('first slotRenderEnded ')
					
					//load lazy slots automatically
					try{
						if(typeof(__gh__coreData.globalVariables.ads.lazyStart) !== 'undefined'){
							var callbackObjectLazyStart = {
								"callback":function(lazyStart){
									__gh__webApp.utilities.lazyAds.loadAdsIsNotOnScreen(lazyStart)
								},
								"data": __gh__coreData.globalVariables.ads.lazyStart
							};
							
							__gh__webApp.ads.dfp.callFunction(callbackObjectLazyStart);
	
						}
					}
					catch(e){
						debug.info('loadAdsIsNotOnScreen fail '+e)
					}
				 }
				 
				 
				});
				return true;
			});
		}
		catch (e) {
		   //handle any exceptions
		   debug.info('Error adding slotRenderEnded listener. '+e)
		   return false;
		}

	},
	"isDisabled": function(){
		var commonJS = __gh__webApp.common,
			isDisabled =(commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"ads.dfp.firstLevelAdUnit") && __gh__coreData["3rdPartyData"].ads.dfp.firstLevelAdUnit && __gh__coreData["3rdPartyData"].ads.dfp.firstLevelAdUnit!='disabled') ? false : true;
		return isDisabled;
	},
	"checkType": function(slotName) {
		 try{
		 var $adUnit =$("#"+slotName);
		 //debug.log("slotName="+slotName)
		 //debug.log("$adUnit="+$adUnit)
					//targeting=$adUnit.attr('data-targeting'),
					checktargeting=$adUnit.attr('data-gh-lazy-ad-bucket-targeting')
					//debug.log("checktargeting="+checktargeting)
					var myObject = JSON.parse(checktargeting);
					return myObject['ad-type'];
			}
			catch(e){
				debug.warn("Error checking type = "+e)
				return false;
			}
		 
	},
	"callbackFunction": function() {
		if (!__gh__webApp.ads.dfp.callbacks.length){ return; }
			__gh__webApp.ads.dfp.callbacks.push({"callback":function(){
				 __gh__webApp.ads.dfp.callbacks = [];
			}});
			
			/*__gh__webApp.ads.dfp.callbacks.push({"callback":function(){
				 debug.log("Push last item to callbacks.")
			}});*/
		__gh__webApp.common.callArrayOfFunctions(__gh__webApp.ads.dfp.callbacks);
	},
	"callFunction": function(callbackObject){
		
		__gh__webApp.ads.dfp.callbacks.push(callbackObject);
		
		if (!__gh__webApp.ads.dfp.isLoaded) {return;}
		//debug.log("__gh__webApp.ads.dfp.isLoaded="+__gh__webApp.ads.dfp.isLoaded)
		__gh__webApp.ads.dfp.callbackFunction();
	},
	
	/**
	 * Load Top Bar Sponsor if enabled
	 */
	"topBarSponsor": function() { 
		
		try{
		    if(__gh__coreData["3rdPartyData"].ads.dfp.topBarSponsor == 'true'){
				//var container = '.ad-topbanner';
				//this.triggerSlot(container);
				
			var callbackObjectTopBar = {
				"callback":function(container){
					__gh__webApp.ads.dfp.triggerSlot(container);
				},
				"data": ".ad-topbanner"
			};
			
			__gh__webApp.ads.dfp.callFunction(callbackObjectTopBar);
				
				//debug.log('topBarSponsor . ')
			}
		} catch(e){
			debug.log('topBarSponsor error. '+e)
		}
	}


	 
 };
 
 //Array of callbacks
__gh__webApp.ads.dfp.callbacks = [];
__gh__webApp.ads.dfp.isLoaded = false;
__gh__webApp.ads.dfp.slotNames = [];

__gh__webApp.ads.dfp.taxonomyMap = {
				"taxonomy": {
					"sports" : "sports",
					"preps"	 : "sports",
					"high school"	 : "sports",
					"hockey"	 : "sports",
					"mlb"	 : "sports",
					"nba"	 : "sports",
					"nfl"	 : "sports",
					"ice hockey"	 : "sports",
					"dcpreps"	 : "sports",
					"motor racing network"	 : "sports",
					"baseball" : "sports",
					"basketball" : "sports",
					"cheerleading" : "sports",
					"cross country" : "sports",
					"football" : "sports",
					"golf" : "sports",
					"ice hockey" : "sports",
					"lacrosse" : "sports",
					"soccer" : "sports",
					"softball" : "sports",
					"stars" : "sports",
					"swimming and diving" : "sports",
					"tennis" : "sports",
					"track and field" : "sports",
					"volleyball" : "sports",
					"wrestling" : "sports",
					"conference" : "sports",
					"hs bowling" : "sports",
					"staff" : "sports",
					"big 10" : "sports",
					"fighting illini" : "sports",
					"grand valley state" : "sports",
					"hope college" : "sports",
					"ohio state university buckeyes" : "sports",
					"case" : "sports",
					"central Mass" : "sports",
					"connolly" : "sports",
					"diman" : "sports",
					"dual county league" : "sports",
					"other leagues" : "sports",
					"somerset" : "sports",
					"stang" : "sports",
					"swansea" : "sports",
					"tiverton" : "sports",
					"tri-valley league" : "sports",
					"news" : "news",
					"entertainment": "entertainment",
					"local entertainment": "entertainment",
					"tempo": "entertainment",
					"go": "entertainment",
					"books": "lifestyle",
					"movies": "entertainment",
					"weather"	:	"weather",
					"lifestyle" : "lifestyle",
					"food and drink" : "lifestyle",
					"health" : "lifestyle",
					"opinion"	: "opinion",
					"editorials"	: "opinion",
					"letters"	: "opinion",
					"obituaries": "obituaries",
					"frontpage": "homepage", //__gh__coreData.pageData.pageType
					"sectionVideo": "video",
					"PHOTOGALLERY": "photos", //__gh__coreData.pageData.pageType = section && __gh__coreData.pageData.categoryID ==PHOTOGALLERY
					"jobs": "jobs",//__gh__coreData.pageData.categoryID = blank right now
					"classifieds": "classifieds",//__gh__coreData.pageData.categoryID = blank right now
					"realestate": "homefinders",
					"real estate": "homefinders",
					"hdca": "homefinders",
					"cape homes": "homefinders",
					"real estate cover": "homefinders",
					"cars": "auto", //__gh__coreData.pageData.categoryID
					"automotive": "auto",
					"business": "business",
					"business news": "business",
					"52": "business",
					"pearl harbor": "specialsection",
				}
			}
 
/*
|--------------------------------------------------------------------------
| Ads: Nativo
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.ads.nativo = {
	
	/**
	 * Initialize
	 */
	"init": function(){
		//debug.log('init nativo')
		this.loadLibrary();
		//this.renderPlacement(); //PostRelease.Start() undefined... need a dependency here
	},
	
	/**
	 * Load Library
	 */
	"config": function(){
		//load setting to disable native placement rendering until PostRelease.Start() called
			__gh__webApp.common.loadScript({
				"text": "var _prx = window._prx || [];_prx.push(['cfg.SetNoAutoStart']);"
			});
	},
	
	/**
	 * Load Library
	 */
	"loadLibrary": function(){
		var thisObject=this,
			adsGlobal=__gh__coreData.globalVariables.ads;
		if(!adsGlobal.nativeLoaded){
			thisObject.config();
			__gh__webApp.common.loadScript({
				"src": "//s.ntv.io/serve/load.js",
				"async": false,
				"onload": function(){thisObject.renderPlacement();}
			});
		}
		
		adsGlobal.nativeLoaded=true;
		return;
		
	},
	
	/**
	 * Load Library
	 */
	"renderPlacement": function(){
		PostRelease.Start()
	}

};
